
import { Invoice } from "@/script/apps/user/entity/UserEntity";

import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { InvoiceService } from "@/script/apps/user/service/InvoiceService";
import { DictUtil } from "@/script/core/Dict";

@Options({})
export default class InvoiceList extends BaseList {
  private queryEntity: Invoice = {};

  private dataList: Invoice[] = [];

  private service = new InvoiceService();

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_user_invoice",
      "/user/invoice",
      "/user/invoice",
      this.service
    );
    data.typesName = "uc-invoice-type";
    return data;
  }

  public initQueryEntity() {
    this.queryEntity = {
      user: { realName: "" },
    };
    return this.queryEntity;
  }

  public afterLoadList(data: any): void {
    const currDataList: Invoice[] = data.list as Invoice[];
    currDataList.forEach((item) => {
      if (this.serviceContext.typesName) {
        item.typeName = DictUtil.getItemName(this.types, item.type);        
      }
      item.defaultName = item.default ? "是" : "否";
    });
    this.dataList = currDataList;
  }
}
